import WIDGETS from './widgets';

export default {
	name: 'opti_survey_preview',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [
		{
			content: WIDGETS.OPTI_SURVEY_PREVIEW,
			breakpoints: { xs: 12 },
			lazy_loading: 0,
		},
	],
};
